import { useContext, useEffect, useState } from 'react';
import CloudFunctionClientContext from 'contexts/CloudFunctionClientContext';

import getAdminUserList from 'api/getAdminUserList';
import getEditorUserList from './getEditorUserList';

const useAdminsAndEditors = () => {
  const { api } = useContext(CloudFunctionClientContext);
  const [adminsAndEditors, setAdminsAndEditors] = useState<
    (UserManagement.SignedUpUser | UserManagement.PendingUser)[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([getAdminUserList(api), getEditorUserList(api)]).then(
      ([admins, editors]) => {
        const seen = new Set<string>();
        const merged = [...admins, ...editors].filter((user) => {
          if (seen.has(user.id)) {
            return false;
          }
          seen.add(user.id);
          return true;
        });
        setAdminsAndEditors(merged);
        setIsLoading(false);
      },
    );
  }, [api]);

  return {
    isLoading,
    adminsAndEditors,
  };
};

export default useAdminsAndEditors;
